import { render, staticRenderFns } from "./EnrollmentsList.vue?vue&type=template&id=32cf6ada&scoped=true&"
import script from "./EnrollmentsList.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf6ada",
  null
  
)

export default component.exports